/* Demo product layout: independent live view; never resize or relocate the app gallery. */
(() => {
  const init = () => {
    if (!document.querySelector("product-info, .product") || document.getElementById("cd-live-toggle")) return;
    const mobile = window.matchMedia("(max-width: 749px)");
    const toggle = document.createElement("button");
    toggle.type = "button";
    toggle.id = "cd-live-toggle";
    toggle.textContent = "Live Vorschau anzeigen";
    toggle.setAttribute("aria-expanded", "false");
    toggle.setAttribute("aria-controls", "cd-live-preview");
    const launcher = document.createElement("div");
    launcher.id = "cd-live-launcher";
    const dismiss = document.createElement("button");
    dismiss.id = "cd-live-dismiss";
    dismiss.type = "button";
    dismiss.textContent = "×";
    dismiss.setAttribute("aria-label", "Vorschau-Button am Rand einklappen");
    const dock = document.createElement("button");
    dock.id = "cd-live-dock";
    dock.type = "button";
    dock.textContent = "‹";
    dock.setAttribute("aria-label", "Live-Vorschau-Button wieder einblenden");
    launcher.append(toggle, dismiss, dock);
    const panel = document.createElement("aside");
    panel.id = "cd-live-preview";
    panel.hidden = true;
    panel.setAttribute("aria-label", "Live Vorschau deiner Gestaltung");
    const viewport = document.createElement("div");
    viewport.className = "cd-live-viewport";
    viewport.setAttribute("aria-hidden", "true");
    const close = document.createElement("button");
    close.type = "button";
    close.className = "cd-live-close";
    close.setAttribute("aria-label", "Live Vorschau schließen");
    close.textContent = "×";
    panel.append(viewport, close);
    const style = document.createElement("style");
    style.textContent = `
      #cd-live-toggle {position:fixed;right:16px;top:100px;z-index:45;border:0;border-radius:22px;background:#2f2f2f;color:#fff;font-family:inherit;font-size:12px;font-weight:600;line-height:1.3;padding:12px 15px;box-shadow:0 2px 8px #0002;cursor:pointer;display:none}
      #cd-live-preview {position:fixed;inset:0 0 auto;z-index:45;background:#fff;box-shadow:0 3px 14px #0002;padding:0;box-sizing:border-box}
      #cd-live-preview[hidden] {display:none!important}
      .cd-live-viewport {position:relative;margin:auto;overflow:hidden;pointer-events:none}
      .cd-live-viewport>.tee-mockup {position:absolute!important;top:0;left:0;transform-origin:top left;pointer-events:none}
      #cd-live-preview .cd-live-close {position:absolute!important;top:max(10px, env(safe-area-inset-top))!important;right:10px!important;z-index:100!important;width:40px!important;height:40px!important;min-width:40px;min-height:40px;display:grid!important;place-items:center;padding:0!important;border:1px solid #e3d5ca!important;border-radius:50%!important;background:#fff!important;color:#2a160c!important;box-shadow:0 2px 10px #0003;font-size:30px!important;line-height:1!important;opacity:1!important;visibility:visible!important;cursor:pointer;pointer-events:auto!important}
      #cd-live-launcher {position:fixed;right:16px;top:100px;z-index:45;display:none;align-items:center;background:#2f2f2f;border-radius:24px;box-shadow:0 2px 8px #0002}
      #cd-live-launcher #cd-live-toggle {position:static;box-shadow:none;padding:12px 6px 12px 15px}
      #cd-live-dismiss,#cd-live-dock {border:0;color:#fff;background:transparent;font-family:inherit;cursor:pointer;box-sizing:border-box}
      #cd-live-dismiss {width:36px;height:40px;font-size:23px;padding:0 5px 0 0;line-height:1;display:grid;place-items:center}
      #cd-live-dock {width:24px;height:44px;padding:0;font-size:28px;line-height:1;display:grid;place-items:center}
      #cd-live-launcher button[hidden] {display:none!important}
      #cd-live-launcher.is-parked {right:0;border-radius:10px 0 0 10px}
      @media(min-width:750px){#cd-live-preview,#cd-live-toggle,#cd-live-launcher{display:none!important}}
    `;
    document.head.append(style);
    document.body.append(launcher, panel);
    let parked = false;
    let open = false;
    let timer = null;
    let root = null;
    let gallery = null;
    const draw = () => {
      if (!open || panel.hidden) return;
      const source = gallery?.querySelector(".tee-slide--active .tee-hover-zoom-normal .tee-mockup")
        || gallery?.querySelector(".tee-slide--active .tee-mockup")
        || gallery?.querySelector(".tee-mockup");
      if (!source) { viewport.replaceChildren(); return; }
      const width = source.offsetWidth;
      const height = source.offsetHeight;
      if (!width || !height) return;
      const scale = window.innerWidth / width;
      const copy = source.cloneNode(true);
      // Prefix local SVG definitions, while keeping references to Teeinblue's live artwork.
      const ids = new Map();
      copy.querySelectorAll("[id]").forEach(el => {
        const old = el.id;
        const next = "cd-live-" + old;
        ids.set(old, next);
        el.id = next;
      });
      if (copy.id) copy.removeAttribute("id");
      copy.querySelectorAll("*").forEach(el => {
        for (const attr of Array.from(el.attributes)) {
          let value = attr.value;
          ids.forEach((next, old) => {
            if (value === "#" + old) value = "#" + next;
            value = value.split("url(#" + old + ")").join("url(#" + next + ")");
          });
          if (value !== attr.value) el.setAttribute(attr.name, value);
        }
      });
      copy.style.transform = "scale(" + scale + ")";
      copy.style.width = width + "px";
      copy.style.height = height + "px";
      viewport.style.width = width * scale + "px";
      viewport.style.height = height * scale + "px";
      viewport.replaceChildren(copy);
    };
    const schedule = () => {
      if (!open || timer !== null) return;
      timer = setTimeout(() => { timer = null; sync(); draw(); }, 80);
    };
    const setOpen = (value) => {
      open = value;
      toggle.setAttribute("aria-expanded", String(value));
      sync();
      if (value) draw();
    };
    const sync = () => {
      const form = document.getElementById("tee-artwork-form");
      gallery = document.querySelector(".product__media-wrapper .tee-gallery");
      const rect = form?.getBoundingClientRect();
      const active = mobile.matches && gallery && rect && rect.top < window.innerHeight && rect.bottom > 0;
      launcher.style.display = active && !open ? "flex" : "none";
      launcher.classList.toggle("is-parked", parked);
      toggle.style.display = active && !open && !parked ? "block" : "none";
      dismiss.hidden = parked;
      dock.hidden = !parked;
      panel.hidden = !(active && open);
      if (!active && open) {
        open = false;
        toggle.setAttribute("aria-expanded", "false");
      }
    };
    const observer = new MutationObserver(() => { sync(); schedule(); });
    const bind = () => {
      const next = document.querySelector("product-info") || document.querySelector(".product");
      if (next && next !== root) {
        observer.disconnect();
        root = next;
        observer.observe(root, {subtree:true,childList:true,attributes:true,characterData:true});
      }
      sync();
      schedule();
    };
    dismiss.addEventListener("click", () => {parked = true; sync(); dock.focus({preventScroll:true});});
    dock.addEventListener("click", () => {parked = false; sync(); toggle.focus({preventScroll:true});});
    toggle.addEventListener("click", () => { setOpen(true); close.focus({preventScroll:true}); });
    close.addEventListener("click", () => { setOpen(false); if (toggle.style.display !== "none") toggle.focus({preventScroll:true}); });
    document.addEventListener("keydown", e => { if (e.key === "Escape" && open) {setOpen(false);toggle.focus({preventScroll:true});} });
    document.addEventListener("teeinblue-event-component-injected", bind);
    window.addEventListener("scroll", sync, {passive:true});
    window.addEventListener("resize", () => {sync();schedule();}, {passive:true});
    document.addEventListener("visibilitychange", () => {if(document.hidden)setOpen(false);});
    bind();
    // App injection can finish after DOMContentLoaded.
    setTimeout(bind, 1500);
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init, {once:true});
  else init();
})();
